<template>
    <div class="mb-1" id="mainHeader">
        <nav class="navbar navbar-expand-lg scrolling-navbar double-nav py-1 pr-2 px-lg-0 px-xl-3"
            :style="skin.header_desktop.nav_bar">
            <div class="container-fluid my-0">
                <div class="float-left" @click="change_view('lobby')" style="cursor:pointer">
                    <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo"
                        :width="skin.header_desktop.logo_width" alt="" style="max-width: 170px;max-height: 45px;">
                </div>
                <div style="width: 70%;" id="navbarText">
                    <div class="d-flex" style="width:100%">
                        <div  v-for="(item,index) in filteredCategories" :key="index" @click="change_view(index)" style="cursor:pointer;display:table;"
                            class="px-3 pe-3 text-center">
                            <span style="display:table-cell;vertical-align:middle;"
                                :style="skin.header_desktop.nav_bar_text + getNavBarStyle(item.url)">{{
                                    translate(item.name) }}</span>
                        </div>
                        <div v-if="skin.customActionButton.enabled" @click="user.token != '' ? action() : login()"
                            style="cursor:pointer;display:table;" class="px-3 pe-3 text-center">
                            <span
                                :style="skin.header_desktop.nav_bar_text + (actualRoute === '' ? (skin.header_desktop.selection ?? 'color: white !important') : '')"
                                style="display:table-cell;vertical-align:middle;"><i
                                    class="fa fa-external-link fa-fw"></i></span>
                        </div>
                    </div>
                </div>
                <div style="width: 20%;" class="d-flex">
                    <div v-if="user.token != ''" class="px-2 pe-2 text-center" style="display:table;width: 65%;" >
                        <div v-if="skin.header_desktop.balance" class="nav-item"
                            :class="skin.my_account.myaccount_type == 'JM' ? '' : 'text-end'"
                            style="cursor:pointer;width:33%;display:table-cell;vertical-align:middle;font-size: 15px;"
                            :style="skin.header_desktop.nav_bar_text">
                            <i @click="showBalanceAction" class="fas fa-coins pr-0 mx-2" :style="skin.header_desktop.selection"></i>
                            <span v-if="showBalance">{{ user.user_data.data ? new
                                Intl.NumberFormat("de-DE", {
                                    minimumFractionDigits:
                                        skin.qBet_config.decimalsQty, maximumFractionDigits:
                                        skin.qBet_config.decimalsQty
                                }).format(balance.saldo) : 0 }}</span>
                        </div>
                        <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.support"
                            class="dropdown nav-item"
                            style="cursor:pointer;width:33%;display:table-cell;vertical-align:middle;">
                            <span :style="skin.header_desktop.nav_bar_text + (this.message_recived ? 'color:red;' : '')"
                                @click="openSupportModalJivo()">
                                <i class="fa-regular fa-comment-dots" :style="skin.header_desktop.selection"></i>
                            </span>
                            <div class="dropdown-menu p-2" aria-labelledby="navbarDropdown3"
                                style="width: 19rem!important;color: #fff!important;background-color: rgba(60,60,60,.9);font-size: 15px;">
                                <div class="text-center">
                                    <span>• {{ translate('mesa') }} •</span>
                                </div>
                                <div class="my-1 mb-1" data-bs-toggle="modal" data-bs-target="#supportJm"
                                    @click="openSupportModal('newMessage')">
                                    <i class="fa-solid fa-paper-plane mx-2"></i>
                                    <span style="">{{ translate('reportar') }}</span>
                                </div>
                                <div class="my-1 mb-1">
                                    <a class="dropdown-item support-item support-item-read"
                                        v-for="(ticket, index) in supportTickets" :key="index" href="#" data-id="402987"
                                        style="color: rgb(197, 194, 194)!important;background-color: rgba(60,60,60,.9);font-size: 15px;"
                                        data-bs-toggle="modal" data-bs-target="#supportJm"
                                        @click="openSupportModal(ticket)">
                                        <!-- <span :style="ticket.leido_user_creacion==1?'color:red;':''"><i class="far fa-comment me-2" aria-hidden="true"></i></span> -->
                                        <span>Ticket #{{ ticket.id }}</span>
                                        <span class="float-end"> {{ countDays(ticket.fecha) }}d <i class="far fa-clock"
                                                aria-hidden="true"></i></span>
                                    </a>
                                </div>
                                <div class="text-center">
                                    <span>• {{ translate('notifi') }} •</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="user.token == '' && skin.register" @click="register"
                        style="cursor:pointer;display:table;width: 100%;" :style="skin.header_desktop.register_btn"
                        class="py-2 px-2 pe-2 text-center">
                        <span style="display:table-cell;vertical-align:middle;">{{ translate("sign_in") }}</span>
                    </div>
                    <div v-if="user.token == '' && skin.login" @click="login"
                        style="cursor:pointer;display:table;width: 100%;" :style="skin.header_desktop.login_btn"
                        class="py-2 px-2 pe-2 text-end">
                        <span style="display:table-cell;vertical-align:middle;"><i class="fas fa-sign-in-alt"></i>
                            {{ translate("log_in") }}</span>
                    </div>
                    <div>
                        <languageSelector :skin="skin" :language="language">
                        </languageSelector>
                    </div>  
                    <div v-if="user.token != ''" style="cursor:pointer;width:35%"
                        class="py-1 me-2 pb-1 px-2 pe-2 text-center nav-item dropdown">
                        <a v-if="skin.my_account.myaccount_type == 'JM'" :style="skin.header_desktop.nav_bar_text"
                            class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="far fa-user mx-2"></i>{{ user.user_data.data ? user.user_data.data.user_name : ''
                            }}
                        </a>
                        <a v-else :style="skin.header_desktop.nav_bar_text" class="nav-link dropdown-toggle" href="#"
                            id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="far fa-user mx-2"></i>{{ user.user_data.data ? user.user_data.data.name : '' }}
                        </a>
                        <div style="color: #fff!important;background-color: rgba(60,60,60,.9);font-size: 15px;"
                            class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.changePassword"
                                id="changePasswordBtn" class="px-2 pe-2" data-bs-toggle="modal"
                                data-bs-target="#changePasswordJm">
                                <span>{{ translate('change_password') }}</span>
                            </div>
                            <div v-if="skin.my_account.myaccount_type == 'JM'">
                                <div v-if="skin.header_desktop.userMenu.balanceHistory" @click="getMovements()"
                                    class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#myAccountJm">
                                    <span>{{ translate('balance_history') }}</span>
                                </div>
                            </div>
                            <div v-else class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#myAccount">
                                <span>{{ translate('balance_history') }}</span>
                            </div>
                            <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.loginHistory"
                                @click="getIngresos()" class="px-2 pe-2 p-1" data-bs-toggle="modal"
                                data-bs-target="#historial_ingresos"> <span>{{ translate('history_ingre') }}</span> </div>
                            <div v-if="skin.header_desktop.userMenu.sportsRules" @click="terms" class="px-2 pe-2 p-1">
                                <span>{{ translate('regulations') }}</span>
                            </div>
                            <!-- <a @click="change_view('results')" class="px-2 pe-2 p-1" :style="skin.header_desktop.servicios_text2"> <span>{{translate("results")}}</span> </a> -->
                            <div v-if="skin.logout" @click="logout" class="px-2 pe-2 p-1"> <span>{{ translate('close') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <div>
            <myAccountJM v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <!-- Button trigger modal -->
            <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
                style="display:none;"></button>
            <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
                style="display:none;"></button>
            <login v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <changePassword v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <register v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        </div>
    </div>
</template>

<script>
import myAccountJM from "./my_account.vue";
import login from "./login.vue";
import register from './register.vue';
import languageSelector from './language.vue';
import changePassword from "./changePassword.vue";
import historialIngresos from "./historialIngresos.vue";
import axios from "axios";
export default {
    name: "mainHeader",
    props: ['skin', 'language', 'translation'],
    data() {
        return {
            showBalance: false,
            userDataLoaded: false,
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
            newMessage: false,
            supportTickets: [],
        }
    },
    components: {
        myAccountJM,
        login,
        register,
        languageSelector,
        changePassword,
        historialIngresos
    },
    methods: {
        getNavBarStyle(view) {
            return view === this.$store.state?.infoRouter?.url
                ? (this.$props.skin.header_desktop.selection ?? 'color: white !important')
                : '';
        },
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        openSupportModalJivo() {
            const jivoElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoElement) {
                    jivoElement.style.display = 'none';
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoElement) {
                    jivoElement.style.display = 'block';
                    jivo_api.open()
                }
                setTimeout(() => {
                    jivo_api.open()
                }, 600);
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);
            }
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        login() {
            document.getElementById('login_btn').click();
        },
        register() {
            document.getElementById('register_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        my_account() {
            window.parent.postMessage(
                {
                    action: 'openSlider',
                    tab: 'recentBets'
                },
                '*'
            );
        },
        change_view(view) {
            this.$store.dispatch("changeView", view);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        }
    },
    computed: {
        filteredCategories() {
            return this.$props.skin.categories.filter(category => category.active);
        },
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        actualRoute() {
            return this.$store.getters["getActualRoute"]
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
        header_productsQty() {
            let products = [this.$props.skin.poker, this.$props.skin.prematch, this.$props.skin.casinoN, this.$props.skin.casino_live, this.$props.skin.hipicas, this.$props.skin.login, this.$props.skin.logout];
            return products.filter(x => x == true).length + 1;
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight + 5);
        this.$root.$on('openLogin', () => {
            this.login();
        });
    },
    watch: {
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    beforeDestroy() {
        this.$root.$off('openLogin');
    }
}
</script>

<style scoped>
.center_div {
    width: 90%;
    /* Can be in percentage also. */
    height: auto;
    margin: 0 auto;
    padding: 0px;
    position: relative;
}
</style>